import { faCircleCheck, faListAlt } from "@elynx/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Card, CardContent, CardHeader, useTheme } from "@mui/material";
import { format } from "date-fns";
import React, { ReactNode /*, useState*/ } from "react";
import { useTranslation } from "react-i18next";
import { getObjectTypeName } from "../../common/utilities/GetObjectTypeName";
import ActionMenu from "../action-menu/ActionMenu";
import { ActionMenuItem } from "../action-menu/ActionMenuItem";
import { FormInstanceItem } from "./CustomFormInstanceListUtils";

export enum CustomFormInstanceActionEnum {
    Edit = 1,
    Delete = 2,
    ToggleExpansion = 3,
    ViewAttachment = 4,
    DownloadAttachment = 5,
    ViewForm = 6
}

export type CustomFormInstanceActionPayloadType = FormInstanceItem;

export type CustomFormInstanceListItemProps = {
    item: FormInstanceItem,
    onAction: (action: CustomFormInstanceActionEnum, payload: CustomFormInstanceActionPayloadType) => void,
    expanded: boolean;
    allowEdit: boolean;
};

export function CustomFormInstanceListItem({
    item,
    onAction,
    //expanded
    allowEdit
}: CustomFormInstanceListItemProps) {
    const theme = useTheme();
    const { t } = useTranslation();

    function getTitle(): ReactNode {
        return (
            <>
                <Box>
                    {item.model?.name}
                </Box>
                {item.objectName &&
                <Box>
                    {`${item.objectName} (${getObjectTypeName(item.objectType)})`}
                </Box>
                }
            </>
        );
    }

    function getSubheader(): ReactNode {
        return (
            <Box>
                {item.openedTimestamp &&
                    <Box>
                        {item.closedTimestamp ? 
                            `${format(item.openedTimestamp, "P pp")} - ${format(item.closedTimestamp, "P pp")}` : 
                            format(item.openedTimestamp, "P pp") 
                        }

                    </Box>
                }
                <Box>
                    {item.closedBy ? item.closedBy : item.openedBy}
                </Box>
                {item.formID && <Box>
                    ID: {item.formID}
                </Box>
                }

            </Box>
        );
    }

    const actionItems = new Array<ActionMenuItem>(
        {
            id: 'view',
            label: t("actions.view"),
            onClick: () => {
                onAction(CustomFormInstanceActionEnum.ViewForm, item);
            },
        },        
        {
            id: 'edit',
            label: t("actions.edit"),
            onClick: () => {
                onAction(CustomFormInstanceActionEnum.Edit, item);
            },
        },
        {
            id: 'delete',
            label: t("actions.delete"),
            onClick: () => {
                onAction(CustomFormInstanceActionEnum.Delete, item);
            },
        }
    );


    const getActionItems = () => {
        let items = item.closedTimestamp ? actionItems.filter(o => o.id !== 'edit') : actionItems;

        if (!allowEdit) {
            items = items.filter(o => o.id === 'view');
        }
        
        return items;
    }
    
    // function toggleExpanded() {
    //     onAction(CustomFormInstanceActionEnum.ToggleExpansion, item);
    // }

    // TODO: All of these special paddings should be handled in theme

    // function onAttachmentAction(action: AttachmentListCardActionEnum, payload: IAttachment) {

    //     if (action === AttachmentListCardActionEnum.View) {
    //         onAction(CustomFormInstanceActionEnum.ViewAttachment, payload);
    //     } else if (action === AttachmentListCardActionEnum.Download) {
    //         onAction(CustomFormInstanceActionEnum.DownloadAttachment, payload);
    //     }

    // }

    return (
        <Card variant="outlined">
            <CardHeader
                sx={{
                    padding: 1,
                }}
                title={getTitle()}
                avatar={

                    item.closedTimestamp ?
                    <Box
                        className="fa-layers fa-fw"
                        sx={{
                            position: 'relative',
                            marginRight: theme.spacing(2)
                        }}>
                        <FontAwesomeIcon icon={faListAlt} 
                            color={theme.palette.grey[500]}
                            size={'2x'} 
                        />
                        <FontAwesomeIcon icon={faCircleCheck} 
                            style={{
                                bottom: theme.spacing(-3),
                                right: theme.spacing(-4)
                            }}
                            //color={theme.palette.grey[800]}
                            color={'green'}
                            transform="shrink-1" 
                        />
                    </Box> :

                    <FontAwesomeIcon 
                        icon={faListAlt} 
                        size={'2x'} 
                        />}
                    


                    // <FontAwesomeIcon 
                    //     icon={item.closedTimestamp ? 
                    //     faSquareCheck : 
                    //     faListAlt
                    //     } 
                    //     size={item.closedTimestamp ? '3x' : '2x'} 
                    //     //size='2x' 
                    //     color={item.closedTimestamp ? theme.palette.grey[500] : undefined}
                    //     />}
                //avatar={<DynamicForm fontSize="large" />}
                subheader={getSubheader()}
                action={<ActionMenu actionItems={getActionItems()} />}
            >
            </CardHeader>
            <CardContent 
                sx={{
                    padding: (theme) => `0 ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(1)} !important`,
                }}>
                {/* <Typography component="div" variant="body2">

                    <Box>{`${t("runTicket.ticketNumber")}: ${item.ticketNumber}`}</Box>
                    <Box>{`${t("runTicket.oilHaul")}: ${tankLevelEstimatedHaul} Barrels`}</Box>

                    {Number.isFinite(interfaceLevelEstimatedHaul) &&
                        <Box>{`${t("runTicket.waterHaul")}: ${interfaceLevelEstimatedHaul} Barrels`}</Box>
                    }

                    {(item.purchaserName?.length ?? 0) > 0 &&
                        <Box>{`${t("runTicket.purchaser")}: ${item.purchaserName}`}</Box>
                    }

                    {(item.comments?.length ?? 0) > 0 &&
                        <Box>{`${t("runTicket.comments")}: ${item.comments}`}</Box>
                    }
                </Typography> */}
            </CardContent>
        </Card>
    );
}
